import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";

const CrmContext = createContext(null);
const MARKET_KEY = "invictus_crm_market";

export function CrmProvider({ children }) {
  const { pathname } = useLocation();
  const [user, setUser] = useState(null); // null = checker, false = ikke logget ind
  const [market, setMarketState] = useState(() => window.localStorage.getItem(MARKET_KEY) || "DK");
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    if (!pathname.startsWith("/admin/crm") || pathname === "/admin/crm/login") {
      setUser(false);
      return;
    }
    api.get("/crm/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, [pathname]);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/crm/auth/login", { email, password });
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) };
    }
  };

  const logout = useCallback(async () => {
    try {
      await api.post("/crm/auth/logout");
    } finally {
      setUser(false);
    }
  }, []);

  const setMarket = useCallback((value) => {
    window.localStorage.setItem(MARKET_KEY, value);
    setMarketState(value);
    setSelectedIds([]);
  }, []);

  return (
    <CrmContext.Provider value={{ user, login, logout, market, setMarket, selectedIds, setSelectedIds }}>
      {children}
    </CrmContext.Provider>
  );
}

export const useCrm = () => useContext(CrmContext);
